import util from './util'

let TaggedPosts = Vue.component('tagged-posts', {
	props: ['id', 'tagName'],
	data() {
		return {
			posts: [],
			pushFix: true
		}
	},
	methods: {
		onClick: util.onClickDefaultLink
	},
	mounted() {
		util.getTaggedPosts(this.id).then((response) => {
			console.log(response)
			this.posts = response
			this.pushFix = false
		}).catch((e) => {
			console.log(e)
			this.pushFix = false
		})
	},
	template: `
		<div>
			<transition-group name="fade" tag="ul" class="post-list">
				<span class="post-list-label" :key="tagName" v-if="tagName">Texts related to "{{ tagName }}"</span>
				<li v-for="post in posts" :key="post.id">
					<colored-link :type="post.type" :data-id="post.id" :href="post.link" v-html="post.title.rendered"></colored-link>
				</li>
			</transition-group>
		</div>`
})

export default TaggedPosts
